import { Component, OnInit } from '@angular/core';
import { PlatformCommand } from '@shared/commands/command-base';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import { Api } from '@shared/constants/common-field.constants';
import {DialogModel} from "@shared/models/dialog.model";

@Component({
    standalone: false,
    selector: 'app-cbc-auto-exchange-dialog-editor',
  templateUrl: './cbc-auto-exchange-dialog-editor.component.html',
  styleUrls: ['./cbc-auto-exchange-dialog-editor.component.scss']
})
export class CbcAutoExchangeDialogEditorComponent implements OnInit, IDialogView {

  data: DialogModel;
  item: any;
  fieldDefinition: any;

  cbcAutomaticExchangeDefaultValue: any;
  autoExchangeOverwrite: any = false;
  overwrittenCellValue: any;



  constructor() { }

  ngOnInit(): void {
    this.item = this.data.input['item'];
    this.fieldDefinition = this.data.input['fieldDefinition'];
    this.cbcAutomaticExchangeDefaultValue = this.item.cells['CbCAutomaticExchangeDefaultValue'].displayText;
    const autoExchangeOverwriteValue = this.item.cells['IsCbCAutomaticExchangeOverwritten'].displayText;
    this.overwrittenCellValue = this.item.cells['CbCAutomaticExchange'].displayText;
    if(autoExchangeOverwriteValue === 'Yes'){
      this.autoExchangeOverwrite = true;
    }
  }

  onOkClicked(): any {
    this.data.input.NextExecutionCommand = this.getNextExecutionCommand();
    this.data.input.HasUpdate = this.HasUpdate();
    return true;
  }

  getNextExecutionCommand(){
    const command = new PlatformCommand('UpdateCbCComplianceCommand', Api.DueDateTracker);
    command.setValue('AutoExchangeRequiredCell', true);
    command.setValue('ItemId', this.item.id);
    command.setValue('HasAutoExchange', this.overwrittenCellValue === 'Yes');
    command.setValue('AutoExchangeOverwritten', this.autoExchangeOverwrite);
    command.setValue('StrategyType', 'UpdateCbCAutoExchangeStrategy');
    command.projectId = '[PROJECT_ID]';
    return command;
  }

  private HasUpdate(): boolean {
    if(this.overwrittenCellValue !== this.item.cells['CbCAutomaticExchange'].displayText) return true;
    else if(this.autoExchangeOverwrite !== this.ConvertBoolean(this.item.cells['IsCbCAutomaticExchangeOverwritten'].displayText)){
      return true;
    }
    return false;
  }

  private ConvertBoolean = (value: any): boolean => value === 'Yes';
}
